import React from 'react';

import logoMark from '../../../../res/images/logo-mark.svg';

/**
 * The spinning logo where a whole page or tab is still on its way — the same
 * ring and pulse as the boot loader and the app's `Spinner`, whose animation
 * lives in `public/index.html`, keyed off `#loaderIn`.
 *
 * Unlike `Spinner` it does not claim the viewport or paint white: it centres
 * itself in the content area under the header, on the page's own background.
 * `label` is read out in place of the old line of copy.
 */
const PageLoader = ({ label }) => (
    <div className="tw-flex tw-min-h-[60vh] tw-w-full tw-items-center tw-justify-center">
        <div id="loaderIn" role="status" aria-label={label}>
            <img className="loaderMark" src={logoMark} alt="" />
        </div>
    </div>
);

export default PageLoader;
